import { render, staticRenderFns } from "./Uedior.vue?vue&type=template&id=715d1372"
import script from "./Uedior.vue?vue&type=script&lang=js"
export * from "./Uedior.vue?vue&type=script&lang=js"
import style0 from "./Uedior.vue?vue&type=style&index=0&id=715d1372&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports